function waitForElement(elementQuery, callBack) {
  window.setTimeout(function () {
    var element = document.querySelector(elementQuery);
    if (element) {
      callBack(elementQuery, element);
    } else {
      waitForElement(elementQuery, callBack);
    }
  }, 100);
}

function product_add_to_cart() {
  if (document.querySelector(".product-form-wrapper .add-to-cart")) {
    document
      .querySelector(".product-form-wrapper .add-to-cart")
      .addEventListener("click", () => {
        const price = document.querySelector(
          "#product-form .product-form-wrapper .total-price"
        )?.innerText;
        const name = document.querySelector("#product-title")?.innerText;
        const category = document.querySelector(
          ".breadcrumb-wrapper nav.breadcrumb span:last-child"
        )?.innerText;

        window.dataLayer.push({ product: null });
        window.dataLayer.push({
          event: "product_add_to_cart",
          product: {
            price: parseInt(price.replace(/[^0-9.]/g, "")),
            name: name,
            category: category,
          },
        });
      });
  }
}

function gtm_send_fabric_info(name, category, source) {
  plausible("view fabric info", {
    props: {
      info_sample_name: name,
      info_sample_category: category,
      info_sample_source: source,
    },
  });
  window.dataLayer.push({ product: null });
  window.dataLayer.push({
    event: "view_fabric_info",
    product: {
      name: name,
      category: category,
      source: source,
    },
  });
}

function gtm_fabric_add_to_cart(name, category, source) {
  console.log(name, category, source);
  plausible("fabric add to cart", {
    props: {
      added_sample_name: name,
      added_sample_category: category,
      added_sample_source: source,
    },
  });
  window.dataLayer.push({ product: null });
  window.dataLayer.push({
    event: "fabric_add_to_cart",
    product: {
      name: name,
      category: category,
      source: source,
    },
  });
}

function similar_sofa_event(productName, currentPath, similarProductPath) {
  console.log(productName, currentPath, similarProductPath)
  plausible("click similar sofa", {
    props: {
      product_name: productName,
      current_product_path: currentPath,
      similar_product_path: similarProductPath,
    },
  });
  window.dataLayer.push({ product: null });
  window.dataLayer.push({
    event: "click_similar_sofa",
    product: {
      product_name: productName,
      current_product_path: currentPath,
      similar_product_path: similarProductPath,
    },
  });
}

function fabric_add_to_cart() {
  if (window.location.href.includes("/pages/")) {
    // fabric sample or pages

    if (document.querySelector(".fs-fabric-button")) {
      document
        .querySelectorAll(".fs-fabric-button, .fs-add-sample-btn") // :not(.in-cart)
        .forEach((button) =>
          button.addEventListener("click", () => {
            var name = null;
            var category = null;
            if (button.classList.contains("fs-fabric-button")) {
              name =
                button.parentNode.querySelector(".fs-fabric-name")?.innerText;
              category =
                button.parentNode.querySelector(".fs-fabric-group")?.innerText;
            } else {
              name =
                button.parentNode.querySelector(
                  ".fs-fi-fabric-name"
                )?.innerText;
              category = button.parentNode.querySelector(
                ".fs-fi-fabric-group"
              )?.innerText;
            }

            if (button.classList.contains("in-cart")) {
              plausible("remove fabric from cart", {
                props: {
                  removed_sample_name: name,
                  removed_sample_category: category,
                  removed_sample_source: window.location.href.includes(
                    "fabric-samples"
                  )
                    ? "Fabric sample page"
                    : "Collection page",
                },
              });
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                  value: 0,
                  items: [
                    {
                      item_name: category + " " + name,
                      price: 0,
                    },
                  ],
                },
              });
            } else {
              window.location.href.includes("fabric-samples")
                ? gtm_fabric_add_to_cart(name, category, "Fabric sample page")
                : gtm_fabric_add_to_cart(name, category, "Collection page");
            }
          })
        );
    }
  } else if (window.location.href.includes("/products")) {
    if (document.querySelector("#add-to-cart")) {
      var button = document.querySelector("#add-to-cart");
      button.addEventListener("click", () => {
        const name = button.parentNode.querySelector(
          ".fs__fd__top-text span.fabric_name"
        )?.innerText;
        const category = button.parentNode.querySelector(
          ".fs__fd__top-text p span"
        )?.innerText;

        if (button.classList.contains("active")) {
          console.log("removing fabric from the cart");
          plausible("remove fabric from cart", {
            props: {
              removed_sample_name: name,
              removed_sample_category: category,
              removed_sample_source: "Product page",
            },
          });
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
              value: 0,
              items: [
                {
                  item_name: category + " " + name,
                  price: 0,
                },
              ],
            },
          });
        } else {
          gtm_fabric_add_to_cart(name, category, "Product page");
        }
      });
    }
  }
}

function view_cart() {
  if (document.querySelector("a.header-cart-link")) {
    document
      .querySelector("a.header-cart-link")
      .addEventListener("click", () => {
        waitForElement("div.header-cart-wrapper", function () {
          if (!document.querySelector(".empty-cart")) {
            const totalPrice = document.querySelector(
              "div.header-cart-wrapper .header-cart-bottom .price"
            ).innerText;
            let items = [];
            let itemNodes = document.querySelectorAll(
              "div.header-cart-wrapper .header-cart-middle .header-cart-items li .details-con"
            );
            itemNodes.forEach((item) => {
              const quantity = item.querySelector(
                ".left-side .global-form-qty input"
              )
                ? item.querySelector(".left-side .global-form-qty input").value
                : 1;
              items.push({
                item_name: item.querySelector(".left-side h6").innerText,
                quantity: parseInt(quantity),
                price: parseInt(
                  item
                    .querySelector(".right-side .item-price span")
                    .innerText.replace(/[^0-9.]/g, "")
                ),
              });
            });
            const totalQuantity = document
              .querySelector("div.header-cart-wrapper .header-cart-top h5")?.innerText.match(/\(([^)]+)\)/)[1];

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: "view_cart",
              ecommerce: {
                value: parseInt(totalPrice.replace(/[^0-9.]/g, "")),
                items: items,
              },
            });
          }
        });
      });
  }
}

function remove_from_cart(del_btn) {
  const price = del_btn.parentNode.querySelector(".item-price span").innerText;
  const title =
    del_btn.parentNode.parentNode.querySelector(".left-side h6").innerText;

  plausible("remove from cart", {
    props: {
      removed_item_title: title,
    },
  });

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      value: parseInt(price.replace(/[^0-9.]/g, "")),
      items: [
        {
          item_name: title,
          price: parseInt(price.replace(/[^0-9.]/g, "")),
        },
      ],
    },
  });
}

function plus_cart_item(plus_btn) {
  const price = plus_btn.parentNode.parentNode.parentNode.querySelector(
    ".right-side .item-price span"
  ).innerText;
  const title = plus_btn.parentNode.parentNode.querySelector("h6").innerText;
  const quantity = plus_btn.parentNode.querySelector(
    "input.global-qty-text"
  ).value;
  plausible("increment cart item", {
    props: {
      increment_item_title: title,
    },
  });
  window.dataLayer.push({ item: null });
  window.dataLayer.push({
    event: "increment_cart_item",
    item: {
      price: parseInt(price.replace(/[^0-9.]/g, "")),
      name: title,
      quantity: parseInt(quantity),
    },
  });
}

function minus_cart_item(minus_btn) {
  const price = minus_btn.parentNode.parentNode.parentNode.querySelector(
    ".right-side .item-price span"
  ).innerText;
  const title = minus_btn.parentNode.parentNode.querySelector("h6").innerText;
  const quantity = minus_btn.parentNode.querySelector(
    "input.global-qty-text"
  ).value;
  plausible("decrement cart item", {
    props: {
      decrement_item_title: title,
    },
  });
  window.dataLayer.push({ item: null });
  window.dataLayer.push({
    event: "decrement_cart_item",
    item: {
      price: parseInt(price.replace(/[^0-9.]/g, "")),
      name: title,
      quantity: parseInt(quantity),
    },
  });

  if (quantity == 1) {
    plausible("remove from cart", {
      props: {
        removed_item_title: title,
      },
    });
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        value: parseInt(price.replace(/[^0-9.]/g, "")),
        items: [
          {
            item_name: title,
            price: parseInt(price.replace(/[^0-9.]/g, "")),
          },
        ],
      },
    });
  }
}

function checkout_click(checkout_btn) {
  plausible("checkout");
  const totalPrice =
    checkout_btn.parentNode.parentNode.querySelector(".price").innerText;
  let items = [];
  let itemNodes =
    checkout_btn.parentNode.parentNode.parentNode.querySelectorAll(
      ".header-cart-middle .header-cart-items li .details-con"
    );
  itemNodes.forEach((item) => {
    items.push({
      item_name: item.querySelector(".left-side h6").innerText,
      quantity: item.querySelector(".left-side .global-form-qty input")
        ? item.querySelector(".left-side .global-form-qty input").value
        : 1,
      price: parseInt(
        item
          .querySelector(".right-side .item-price span")
          ?.innerText?.replace(/[^0-9.]/g, "")
      ),
    });
  });

  const totalQuantity = checkout_btn.parentNode.parentNode.parentNode.parentNode
    .querySelector(".header-cart-top h5")?.innerText.match(/\(([^)]+)\)/)[1];
  window.dataLayer.push({ cart: null });
  window.dataLayer.push({
    event: "checkout",
    cart: {
      total_price: parseInt(totalPrice.replace(/[^0-9.]/g, "")),
      items: items,
      total_quantity: parseInt(totalQuantity),
    },
  });

  // to be added -------------------------------------
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "begin_checkout",
    ecommerce: {
      value: parseInt(totalPrice.replace(/[^0-9.]/g, "")),
      items: items,
    },
  });
}

function clickInCart() {
  if (document.querySelector("div#header-cart")) {
    document.querySelector("div#header-cart").addEventListener("click", (e) => {
      e = e || window.event;
      var target = e.target;

      if (target.closest(".close")) {
        // click on delete icon
        remove_from_cart(target.closest(".close"));
      } else if (target.closest(".global-plus")) {
        plus_cart_item(target.closest(".global-plus"));
      } else if (target.closest(".global-minus")) {
        minus_cart_item(target.closest(".global-minus"));
      } else if (
        target.hasAttribute("name") &&
        target.getAttribute("name") === "checkout"
      ) {
        checkout_click(target);
      }
    });
  }
}

function sofaFinderEvents(text) {
  plausible("Sofa Finder Selection", {
    props: {
      sofa_finder_selection_text: text,
      sofa_finder_url: window.location.pathname,
    },
  });
}

// to be added -------------------------------------
function view_item_list() {
  if (window.location.href.includes("/collections/")) {
    // click event towards product
    document.querySelectorAll(".item-box a").forEach((element) =>
      element.addEventListener("click", (event) => {
        plausible("product from collection", {
          props: {
            product_name: element.querySelector(".title h6")?.innerText,
            category_page_path: window.location.pathname,
          },
        });
        window.dataLayer.push({ product: null });
        window.dataLayer.push({
          event: "product_from_collection",
          product: {
            name: element.querySelector(".title h6")?.innerText,
          },
        });
      })
    );
  }
}

// to be added -------------------------------------
function auth_events() {
  if (window.location.href.includes("/login")) {
    plausible("login");
    document
      .querySelector('button[type="submit"]')
      .addEventListener("click", function () {
        dataLayer.push({
          event: "login",
        });
      });
  }
  if (window.location.href.includes("/register")) {
    document
      .querySelector('button[type="submit"]')
      .addEventListener("click", function () {
        plausible("Signup");
        dataLayer.push({
          event: "sign_up",
        });
      });
  }
}

function content_or_collection() {
  if (
    window.location.href.includes("/pages/") ||
    window.location.href.includes("/collections/")
  ) {
    document
      .querySelector("a.item-box.ads")
      ?.addEventListener("click", (event) => {
        window.dataLayer.push({
          event: "fabric_sample_banner",
        });
      });

    document
      .querySelector(".banner-text-only .container button.btn-popup")
      ?.addEventListener("click", (event) => {
        window.dataLayer.push({
          event: "request_banner_button",
        });
      });

    // search input on collections
    let typingTimer;
    const delay = 500; // milliseconds

    const searchInput = document.getElementById("search-inner");

    searchInput?.addEventListener("input", function () {
      clearTimeout(typingTimer);

      typingTimer = setTimeout(function () {
        const inputValue = searchInput.value.trim();
        if (inputValue) {
          plausible("search model");
          window.dataLayer.push({ search: null });
          window.dataLayer.push({
            event: "search_for_model",
            search: {
              value: inputValue,
            },
          });
        }
      }, delay);
    });

    searchInput?.addEventListener("blur", function () {
      clearTimeout(typingTimer);
    });
  }
}

function search() {
  let typingTimer;
  const delay = 500; // milliseconds

  const searchInput = document.getElementById("sinput");

  searchInput?.addEventListener("input", function () {
    clearTimeout(typingTimer);

    typingTimer = setTimeout(function () {
      const inputValue = searchInput.value;
      plausible("search", {
        props: {
          search_term: inputValue,
        },
      });
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "search",
        ecommerce: {
          search_term: inputValue,
        },
      });
    }, delay);
  });

  searchInput?.addEventListener("blur", function () {
    clearTimeout(typingTimer);
  });
}

function timings() {
  if (document.visibilityState && document.visibilityState == 'visible') {
    const entries = performance.getEntriesByType("navigation");
    let theTiming = { domInteractive: 0, domComplete: 0 };
    entries.forEach((entry) => {
      if (entry.domInteractive) {
        theTiming["domInteractive"] = entry.domInteractive;
        theTiming["domComplete"] = entry.domComplete;
      }
    });
    //console.log(theTiming)
    dataLayer.push({ timings: null });
    dataLayer.push({
      event: "page_timings",
      timings: {
        dom_interactive: parseFloat(theTiming.domInteractive),
        dom_complete: parseFloat(theTiming.domComplete),
      },
    });
  }
}

function signUpNewsletter() {
  const newsletterBtn = document.querySelector(".footer-form .needsclick");
  if (newsletterBtn) {
    newsletterBtn.addEventListener("click", function () {
      plausible("Lead Sign up");
    });
  }
}

const updateFabricCard = (itemid) => {
  const buttons = document.querySelectorAll(`.fs-fabric-button.in-cart[data-variant-id="${itemid}"]`);
  const plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="13.5" stroke="#D9D9D9"/><path d="M14.6667 8.66667C14.6667 8.29848 14.3682 8 14 8C13.6318 8 13.3333 8.29848 13.3333 8.66667V13.1201H8.66667C8.29848 13.1201 8 13.4186 8 13.7868C8 14.155 8.29848 14.4535 8.66667 14.4535H13.3333V19.3333C13.3333 19.7015 13.6318 20 14 20C14.3682 20 14.6667 19.7015 14.6667 19.3333V14.4535H19.3333C19.7015 14.4535 20 14.155 20 13.7868C20 13.4186 19.7015 13.1201 19.3333 13.1201H14.6667V8.66667Z" fill="#FC773C"/></svg>`;
  const addBtnContent = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6.66667 0.666667C6.66667 0.298477 6.36819 0 6 0C5.63181 0 5.33333 0.298477 5.33333 0.666667V5.12012H0.666667C0.298477 5.12012 0 5.41859 0 5.78678C0 6.15497 0.298477 6.45345 0.666667 6.45345H5.33333V11.3333C5.33333 11.7015 5.63181 12 6 12C6.36819 12 6.66667 11.7015 6.66667 11.3333V6.45345H11.3333C11.7015 6.45345 12 6.15497 12 5.78678C12 5.41859 11.7015 5.12012 11.3333 5.12012H6.66667V0.666667Z" fill="#252525"/></svg>Add Sample`;

  if(buttons) {
    buttons.forEach(button => {
      if(button.classList.contains('fs-fabric-button')){
        const btnVarId = button.getAttribute("data-variant-id");
        const sisBtns = document.querySelectorAll(`.fs-add-sample-btn.in-cart[data-variant-id="${btnVarId}"]`);
        
        button.innerHTML = plusIcon;
        button.classList.remove("in-cart");
        button.removeAttribute('disabled');
        button.parentNode.parentNode.classList.remove("in-cart-card");
        if (window.location.href.includes("/pages/fabric-samples")) {
          FabricSampleVue.fabricItemsInCart--;
        }

        sisBtns.forEach(sisBtn => {
          sisBtn.innerHTML = addBtnContent;
          sisBtn.classList.remove("in-cart");
          sisBtn.removeAttribute('disabled');
        });
      }
    });
  }
};

function showUpdateCart() {
  $360.showHeaderCart({ update: true });
}

function sendLinkToPlausible(url) {
  plausible("click from search", {
    props: {
      search_click_link: url,
    },
  });
}

function add_remove_bundle(name, title, source) {
  plausible(name, {
    props: {
      AddOn_Title: title,
      AddOn_Location: source,
    },
  });
}

function clickOnLinks() {
  document.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      plausible("Link Click", {
        props: {
          link_page_path: window.location.pathname,
          link_href: link.href || "",
          link_text: link.innerText.trim(),
          link_class: link.className || "",
        },
      });
    });
  });
}

function page_view_after_10s() {
  setTimeout(() => {
    const pageData = {
      page_path: window.location.pathname,
      user_agent: navigator.userAgent,
    };

    plausible("page_view_after_10s", {
      props: pageData,
    });

    window.dataLayer.push({ page_view: null });
    window.dataLayer.push({
      event: "page_view_after_10s",
      page_data: pageData,
    });
  }, 10000); 
}

window.onload = function () {
  timings();
  //page_view_after_10s();
  product_add_to_cart();
  view_cart();
  clickInCart();
  fabric_add_to_cart();
  view_item_list();
  auth_events();
  content_or_collection();
  search();
  signUpNewsletter();
  //clickOnLinks();
};
